import React from "react";
import { Flex, Tag } from "@jsq/ds/core";
import { programRenderer } from "./styles_vanilla.css";

interface ProgramRendererProps {
  value: string[];
}

const ProgramRenderer: React.FC<ProgramRendererProps> = ({ value }) => {
  return (
    <Flex className={programRenderer} gap={2} alignItems="center">
      {value?.map((program?: string) => (
        <Tag data-testid="program-tag" key={program} label={program ?? "N/A"} />
      ))}
    </Flex>
  );
};

export default ProgramRenderer;
